import { render, staticRenderFns } from "./CustomerChangelog.vue?vue&type=template&id=b3520042&scoped=true&"
import script from "./CustomerChangelog.vue?vue&type=script&lang=ts&"
export * from "./CustomerChangelog.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerChangelog.vue?vue&type=style&index=0&id=b3520042&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3520042",
  null
  
)

export default component.exports